import { AuthData } from '@typings/common';
import { authRedirectUri } from 'config/auth';
import queryString from 'query-string';
import { toApiFormat } from 'utils/api';
import { getAppConfig } from 'utils/config/appConfig';
import { addEnvironmentOrigin } from 'utils/string/addPathParameter';

export interface ExchangeAuthCodeResponse {
  result?: AuthData;
  error?: string;
}

export interface ExchangeAuthCode {
  (code: string, environmentOrigin: string, onSuccess?: () => Promise<any>): Promise<ExchangeAuthCodeResponse>;
}

const getAuthorizationUrl = (params: object, environmentOrigin: string) => {
  const apiUrl = getAppConfig('OSIN20_API_URL');
  const url = `${apiUrl}/auth?${queryString.stringify(params)}`;

  return addEnvironmentOrigin(url, environmentOrigin);
};

export const exchangeAuthCode: ExchangeAuthCode = async (
  code: string,
  environmentOrigin: string,
  onSuccess?: () => Promise<any>,
) => {
  const params = toApiFormat({ code, redirectUri: authRedirectUri });
  const response = await fetch(getAuthorizationUrl(params, environmentOrigin), {
    credentials: 'include', // Required for HTTP-only cookies
  });

  if (response.status === 204) {
    // 204 No Content - successful response with no body
    // Server sets HTTP-only cookies for authentication

    // Call onSuccess callback if provided (e.g., to call /me)
    if (onSuccess) {
      try {
        await onSuccess();
      } catch (error) {
        return { error: 'AUTH.FAILED' };
      }
    }

    // Return empty strings to indicate successful authentication
    return { result: { access_token: '', refresh_token: '' } };
  }

  if ([401, 403].includes(response.status)) {
    const data = await response.json();
    return { error: data.error };
  }

  return { error: 'AUTH.FAILED' };
};
